var _path;
import * as React from "react";
function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.667 17.333h-12v-12c0-.736-.597-1.333-1.334-1.333h-2.666c-.737 0-1.334.597-1.334 1.333v12h-12c-.736 0-1.333.597-1.333 1.334v2.666c0 .737.597 1.334 1.333 1.334h12v12c0 .736.597 1.333 1.334 1.333h2.666c.737 0 1.334-.597 1.334-1.333v-12h12c.736 0 1.333-.597 1.333-1.334v-2.666c0-.737-.597-1.334-1.333-1.334z"
  })));
}
export default SvgAdd;